import { Component,  Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';


@Component({
  selector: 'app-input-title.',
  templateUrl: './input-title.component.html',
  styleUrls: ['./input-title.component.scss']
})
export class InputTitleComponent {
  public tooltip = '';

  constructor() { }

  @Input() private value: string;
  @Output() private titleChangeEvent = new EventEmitter<string>();
  @ViewChild('Input') private input: ElementRef;

  onSubmit(value: string) {
    this.titleChangeEvent.emit(value);
  }

  getTooltip(): string {
    return this.value.length > 27 ? this.value : '';
  }

  focusOut(value: string) {
    this.onSubmit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input-title/input-title.component.ts